// eslint-disable-next-line no-restricted-imports
import { useTranslation } from 'react-i18next';

import { allNS } from '../../../src/lib/i18n';
import { I18nResources, Options } from '../../types';

const sanitize = (str: string) => {
  const sanitized = str.replace(/[^a-z0-9áéíóúñü .,_'"-]/gim, '');

  return sanitized.trim();
};

export const useI18n = () => {
  const { t: translate } = useTranslation(allNS);

  const t = (key: I18nResources, options?: Options): string => {
    // i18next marks `context` as unknown while TFunction expects string | undefined.
    const translateFn = translate as (
      key: I18nResources,
      options?: Options
    ) => string;

    return translateFn(key, {
      ...options,
      interpolation: options?.interpolation || {
        escape: (str) => sanitize(str),
      },
    });
  };

  return {
    t,
  };
};
